export enum SocketType {
  F = 'F',
  J = 'J',
  K = 'K',
  E = 'E',
  G = 'G',
  L = 'L',
}
